const selectPrompts = (state) => state.prompts.items || [];

export default {
  selectPrompts,
};
